export const searchBarParamName = "query";